<template>
  <div class="Nav_index">
    <main class="main">
<!--      <mu-slide-right-transition>-->
<!--        <router-view style="height: 100%;" />-->
<!--      </mu-slide-right-transition>-->
      <router-view />
    </main>
    <Nav/>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return{
      msg: "导航",
      url: null,
    }
  },
  created() {
    // this.$progress.start();
  },
  mounted() {
    // this.$progress.done();
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
    @import "../style/Index";
</style>
